import { useEffect, type RefObject } from 'react';
/**
 *
 *
 * Closes the filter menu on mousDown event or touchstart event or keydown event if the event is not on the filter menu.
 */
export function useCloseOnOutsideInteraction(
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  onClose: () => void
): void {
  useEffect(() => {
    if (!isOpen) return;
    const handleInteraction = (event: MouseEvent | TouchEvent | KeyboardEvent) => {
      if ('key' in event) {
        if (event.key === 'Escape') onClose();
        return;
      }
      const target = (event as MouseEvent | TouchEvent).target as Node;
      if (ref.current && !ref.current.contains(target)) onClose();
    };
    document.addEventListener('mousedown', handleInteraction);
    document.addEventListener('touchstart', handleInteraction, {
      passive: true,
    });
    document.addEventListener('keydown', handleInteraction);
    return () => {
      document.removeEventListener('mousedown', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };
    // ref is stable (RefObject from useRef) - intentionally omitted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onClose]);
}
